import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Timeline, TimelineLite} from "gsap";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ImmortalFruitsGameConfig} from "../../ImmortalFruitsGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ImmortalFruitsParsedInitData} from "../../server/data/ImmortalFruitsParsedInitData";
import {SymbolUtil} from "../../utils/SymbolUtil";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";

export class ImmortalFruitsSymbolsWinAnimations extends BaseView {
    private _symAnims: TimelineSprite[][] = [];
    private _layer: ScalableLayer;
    private _numOfRows: number = 5;
    private _numOfCols: number = 5;
    private data:any;
    private _symbolStates:any ;

    constructor (){
        super();
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }
    /**
     * @description To play the symbol animation.
     * @param reelId
     * @param symId
     * @param symbol
     */
    public playAnimation(reelId: number, symId: number, symbol: StateReelSymbol): Timeline {
        let tl: Timeline = new TimelineLite();
        tl.add(symbol.changeState({
                   state: ImmortalFruitsGameConfig.instance.SYMBOL_STATES.win
        }),0);

        return tl;
    }

    /**
     * @description To stop all the animations.
     */
    public stopAllAnimation(): void {
    }
    public noWinSymbols(){
        if(this.data!.betWins!.length>0) {
            for (let reelId = 0; reelId < ImmortalFruitsGameConfig.instance.REELS_NUM; reelId++) {
                const reelCoords: [number, number][] = this._symbolStates.getCoordinatesWithStateInReel(reelId, ImmortalFruitsGameConfig.instance.SYMBOL_STATES.noWin!.keyword);
                for (let coords of reelCoords) {
                    let sym = Reels.getSymbol(coords[0], coords[1])!;
                    if (!(sym!.symName == "S" && this.data && this.data!.nextMode && (this.data!.nextMode === ImmortalFruitsGameMode.BONUS_WHEEL || (this.data!.nextReelSetName && this.data!.nextReelSetName === "BONUS_REELSET")))) {

                        sym!.changeState({
                            state: ImmortalFruitsGameConfig.instance.SYMBOL_STATES.noWin!,
                            setStack: true,
                            fadeInDuration: 0.0
                        })!;
                    }
                }
            }
        }
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        this._layer = StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.SYMBOLS_WIN_ANIM.name);
        this._layer.addChild(this);

    }
    private onInitDataParsed(data:ImmortalFruitsParsedInitData){

         this._symbolStates = SymbolUtil.createSymbolStateMatrixFromBetWins(
            <IBetLineWinData[]>data!.betWins!,
            ImmortalFruitsGameConfig.instance.SYMBOL_STATES.noWin!.keyword,
            ImmortalFruitsGameConfig.instance.SYMBOL_STATES.win!.keyword);
            this.data = data!;
    }
}